/**
 * @fileoverview Configuración de la integración con CR Auth y Apigee.
 * Único punto que lee `process.env` para estas URLs (estándar Environment Configuration).
 * @module utils/environment
 */

/** Identificador de este cliente en el header `Application-ID` de CR Auth. */
export const APPLICATION_ID = 'zonasegura-frontend'

/** Origen con el que el front se identifica ante los backends (mismo valor que el interceptor global). */
export const ORIGIN = 'ZONASEGURA'

export default {
  /**
   * Base de CR Auth, llamado directo y sin Apigee.
   * @returns {string} URL terminada en '/', p. ej. https://…/api/v1/
   */
  getAuthApiUrl () {
    return process.env.AUTH_API_URL
  },

  /**
   * Base de portal-api-zonasegura publicada en Apigee.
   * @returns {string} URL terminada en '/', p. ej. https://…/api/v1/
   */
  getPortalApiUrl () {
    return process.env.API_ZONASEGURA
  },

  /**
   * Base de Vive+ publicada en Apigee (proxy api-ux-vivemas-benefits).
   * @returns {string} URL sin '/' final, p. ej. https://…/vivemas/benefits/v1
   */
  getVivemasApiUrl () {
    return process.env.API_VIVEMAS
  },

  /**
   * API key de la App vivemas-benefits en Apigee, la que tiene el API product de Vive+. No es la de Zona Segura.
   * @returns {string|undefined} Valor de `APIGEE_VIVEMAS_API_KEY`
   */
  getVivemasApiKey () {
    return process.env.APIGEE_VIVEMAS_API_KEY
  },

  /**
   * Bases de la API de Zona Segura publicadas en Apigee. Incluye `API_ZONASEGURA` porque en dev y test apunta al
   * Apigee de producción mientras `API_URL` apunta al portal-admin de test: sin ella, las llamadas a portal-api
   * hechas con el axios global (centro de ayuda) saldrían sin `x-api-key`, trazabilidad ni renovación de sesión.
   * @returns {string[]} URLs de `API_URL`, `API_URL_V2` y `API_ZONASEGURA`
   */
  getZsBackendUrls () {
    return [process.env.API_URL, process.env.API_URL_V2, process.env.API_ZONASEGURA].filter(Boolean)
  },

  /**
   * API key de la App de Zona Segura en Apigee. Identifica a la aplicación, no al usuario: va en el
   * navegador, así que no es secreta (sirve para cuotas, analítica y revocación).
   * @returns {string|undefined} Valor de `APIGEE_API_KEY`
   */
  getApiKey () {
    return process.env.APIGEE_API_KEY
  },

  /**
   * @returns {boolean} true en el ambiente local (`ENVIRONMENT=dev`), donde no se carga reCAPTCHA
   */
  isDev () {
    return process.env.ENVIRONMENT === 'dev'
  }
}



// WEBPACK FOOTER //
// ./src/utils/environment.js